import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { PenTool, Users, FileSearch, Wrench, FileCheck, Building2, Truck, Banknote, Shield, Home, Star, Zap, Heart, Settings } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const iconMap = {
  PenTool, Users, FileSearch, Wrench, FileCheck, Building2, Truck, Banknote, Shield, Home, Star, Zap, Heart, Settings,
};

const TurnkeyServicesSection = () => {
  const { t, i18n } = useTranslation();
  const isZh = i18n.language === 'zh';
  const [services, setServices] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const r = await axios.get(`${API}/admin/turnkey`);
        if (r.data.services?.length > 0) setServices(r.data.services);
      } catch {}
    };
    load();
  }, []);

  // Fallback to i18n if DB is empty
  if (services.length === 0) {
    const fallback = [
      { icon: 'PenTool', titleKey: 'turnkey.design', descKey: 'turnkey.designDesc' },
      { icon: 'Users', titleKey: 'turnkey.projectManager', descKey: 'turnkey.projectManagerDesc' },
      { icon: 'FileSearch', titleKey: 'turnkey.feasibility', descKey: 'turnkey.feasibilityDesc' },
      { icon: 'Wrench', titleKey: 'turnkey.sitePrep', descKey: 'turnkey.sitePrepDesc' },
      { icon: 'FileCheck', titleKey: 'turnkey.permitting', descKey: 'turnkey.permittingDesc' },
      { icon: 'Building2', titleKey: 'turnkey.construction', descKey: 'turnkey.constructionDesc' },
      { icon: 'Truck', titleKey: 'turnkey.delivery', descKey: 'turnkey.deliveryDesc' },
      { icon: 'Banknote', titleKey: 'turnkey.financing', descKey: 'turnkey.financingDesc' },
      { icon: 'Shield', titleKey: 'turnkey.warranty', descKey: 'turnkey.warrantyDesc' },
    ];
    return (
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">{t('turnkey.title')}</h2>
            <p className="text-xl text-gray-600">{t('turnkey.subtitle')}</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {fallback.map((s, i) => {
              const Icon = iconMap[s.icon] || PenTool;
              return (
                <div key={i} className="group bg-gradient-to-br from-white to-gray-50 rounded-xl p-8 shadow-md hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-gray-100">
                  <div className="mb-6"><div className="w-16 h-16 bg-red-50 rounded-lg flex items-center justify-center group-hover:bg-red-600 transition-all duration-300"><Icon className="w-8 h-8 text-red-600 group-hover:text-white transition-colors" /></div></div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-red-600 transition-colors">{t(s.titleKey)}</h3>
                  <p className="text-gray-600 leading-relaxed">{t(s.descKey)}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">{t('turnkey.title')}</h2>
          <p className="text-xl text-gray-600">{t('turnkey.subtitle')}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((s, i) => {
            const Icon = iconMap[s.icon] || PenTool;
            return (
              <div key={s.id || i} className="group bg-gradient-to-br from-white to-gray-50 rounded-xl p-8 shadow-md hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-gray-100">
                <div className="mb-6"><div className="w-16 h-16 bg-red-50 rounded-lg flex items-center justify-center group-hover:bg-red-600 transition-all duration-300"><Icon className="w-8 h-8 text-red-600 group-hover:text-white transition-colors" /></div></div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-red-600 transition-colors">{isZh ? s.title_zh : s.title_en}</h3>
                <p className="text-gray-600 leading-relaxed">{isZh ? s.desc_zh : s.desc_en}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TurnkeyServicesSection;
